import React, { useState, useRef } from "react";
import { useMediaQuery, useDisclosure } from "@chakra-ui/react";
import axios from 'axios';
import {
	Box,
	Drawer,
	DrawerHeader,
	DrawerBody,
	DrawerOverlay,
	DrawerContent,
	DrawerCloseButton,
	Flex,
	LinkBox,
	LinkOverlay,
	IconButton,
	UnorderedList,
	ListItem,
	FormControl,
	FormLabel,
	Input
} from "@chakra-ui/react";
import { Logo } from "../../assets/react/Logo";
import { FiSearch } from "react-icons/fi";

type MobileSearchPanelType = {
	isMobileSearchPanelOpen: boolean;
	onMobileSearchPanelOpen: () => void;
	onMobileSearchPanelClose: () => void
}

interface IResult {
	fields: { [key: string]: string }
}

const MobileSearchPanel = ({isMobileSearchPanelOpen, onMobileSearchPanelOpen, onMobileSearchPanelClose}: MobileSearchPanelType) => {

	const [input, setInput] = useState<string>('')
	const [results, setResults] = useState<IResult[] | []>([])
	const [noresults, setNoresults] = useState<boolean>(false);
	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => setInput(e.target.value)

  const searchInputRef = useRef<HTMLInputElement>(null);
	const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		e.preventDefault();
		axios.get(`https://5mwk0bg4t7.execute-api.us-east-1.amazonaws.com/dev/?q=${input}`)
			.then((res) => {
				if (res.data.hits.hit.length === 0) {
					setNoresults(true);
					setResults([]);
				}
				else {
					setNoresults(false);
					setResults(res.data.hits.hit);
				}
			})
			.catch(err => {
				console.log('Error fetching search data', err)
			})
	}

	return (
		<>
			<Drawer
				isOpen={isMobileSearchPanelOpen}
				onClose={onMobileSearchPanelClose}
				placement="top"
				size="xl"
        initialFocusRef={searchInputRef}
			>
				<DrawerOverlay />
				<DrawerContent>

					{/* top section */}
					<DrawerHeader background='black' padding={{ base: '16px 22px 8px 22px', sm: '32px 45px 16px 45px' }} marginBottom="-2px">
						<Box 
              className="mobilePanel-top-section"
              display="inline-flex" 
              w="100%"
							justifyContent="center"
							alignItems="center"
            >
							<LinkBox>
								<LinkOverlay className="mobile-nav-tiff-logo" href="/">
									<Logo />
								</LinkOverlay>
							</LinkBox>
							<Flex
								position="absolute"
								top={{ base: "18px", sm: "35px" }}
								right={{ base: "23px", sm: "45px" }}
								alignItems="center"
								justify="center"
							>

								<DrawerCloseButton fontSize={{ base: '14px', sm: '26px' }}
									className="mobile-nav-header-icon"
									position='static'
									outline="0 !important"
									border="0 !important"
									marginBottom="0px"
									marginRight="0px"
								/>

							</Flex>

						</Box>
					</DrawerHeader>

					{/* Search body */}
					<DrawerBody background='black' padding={{ base: "35px 60px 90px 60px", sm: "70px 120px 100px 120px" }}>

              <Box>
                <form onSubmit={e => handleSearchSubmit(e)}>
                  <FormControl 
                    display="flex"
                    alignItems="center"
                    borderBottom="2px solid #fff"
                    paddingBottom={{base:"2px", sm:"14px"}}
                    marginBottom={{base:"35px", sm:"70px"}}
                  >
                    <IconButton
                      icon={ <FiSearch /> }
											fontSize={{base:"16px", sm:"28px"}}
                      aria-label="Search"
                      color='#fff'
                      background="000 !important"
                      _hover={{
                        color: "#fff !important",
                        backgroundColor: "black !important",
                      }}
                      outline="0 !important"
                      border="0 !important"
                      marginBottom="0px"
                      marginRight="0px"
                      minWidth={{base:"16px", sm:"40px"}}
                      onClick={e => handleSearchSubmit(e)}
                      display="inline-block"
                    />
                    <FormLabel className="sr-only">Search Input</FormLabel>
                    <Input type='text' placeholder="What are you looking for?" value={input} onChange={(e) => handleInputChange(e)}
                      fontSize={{base:"14px", sm:'22px'}}
                      lineHeight={{base:"14px", sm:'22px'}}
                      fontFamily="Libre Franklin !important, sans-serif" 
                      fontWeight="600 !important"
                      height={{base:"auto", sm:"40px"}}
                      margin={{base:"0 0 0 8px !important"}}
                      padding="0 !important"
                      border="0 !important"
                      outline="0 !important"
                      boxShadow="none !important"
                      color="#fff!important"
                      className="mobile-search-panel-input"
											ref={searchInputRef}
                    />
                  </FormControl>
                </form>
                {noresults && 
                  <Box 
                    fontFamily="Libre Franklin, sans-serif" 
                    fontWeight="600" color="#fff" 
                    fontSize={{base:"12px",sm:"20px"}} 
                    lineHeight={{base:"12px",sm:"20px"}}
                    marginBottom={{base:"24px", sm:"48px"}}
                  >
                    No results found
                  </Box>
                }
                {results.length ? 
                  <Box>
                    <Box 
                      fontFamily="Libre Franklin, sans-serif" 
                      fontWeight="600" color="#fff" fontSize={{base:"12px",sm:"20px"}} lineHeight={{base:"12px",sm:"20px"}} marginBottom={{base:"13px", sm:"26px"}}
                    >
                      Results
                    </Box>
                    <UnorderedList listStyleType="none" marginLeft="0px">
                      {results.map((res, i) => {
                        let updatedText = "";
                        if(res.fields.text_autocomplete[0].length < 90){
                          updatedText = res.fields.text_autocomplete[0];
                        } else {
                          // cut string to the limit of 90
                          updatedText = res.fields.text_autocomplete[0].substring(0, 90);
                          // remove last word and add continuation symbol
                          let lastInd = updatedText.lastIndexOf(" ");
                          updatedText = updatedText.substring(0, lastInd) + "...";
                        }
                        return (
                          <ListItem key={i}>
                            <LinkBox fontSize={{base:'11px', sm:'20px'}}
                              lineHeight={{base:'13px', sm:'22px'}}
                              fontFamily="Libre Franklin, sans-serif"
                              fontWeight="400"
                              padding={{base:'10px 0', sm: '14px 0' }}
                              color="#fff"
                            >
                              <LinkOverlay color="#fff" href={res.fields.url}>
                                {updatedText}
                              </LinkOverlay>
                            </LinkBox>
                          </ListItem>
                        )
                      })}
                    </UnorderedList>
                  </Box>
                : 
                  <Box>
                    <Box>
                      <Box 
                        fontFamily="Libre Franklin, sans-serif" 
                        fontWeight="600" color="#fff" fontSize={{base:"12px",sm:"20px"}} lineHeight={{base:"12px",sm:"20px"}} marginBottom={{base:"13px", sm:"26px"}}
                      >
                        Suggested
                      </Box>
                      <UnorderedList listStyleType="none" marginLeft="0px">
                        <ListItem>
                          <LinkBox fontSize={{base:'11px', sm:'20px'}}
                            lineHeight={{base:'13px', sm:'22px'}}
                            fontFamily="Libre Franklin, sans-serif"
                            fontWeight="400"
                            padding={{base:'10px 0', sm: '14px 0' }} 
                            color="#fff"
                          >
                            <LinkOverlay href='/about-tiff-23?tab=tickets#'>
                              Festival Ticket Information
                            </LinkOverlay>
                          </LinkBox>
                        </ListItem>
                        <ListItem>
                          <LinkBox fontSize={{base:'11px', sm:'20px'}}
                            lineHeight={{base:'13px', sm:'22px'}}
                            fontFamily="Libre Franklin, sans-serif"
                            fontWeight="400"
                            padding={{base:'10px 0', sm: '14px 0' }} 
                            color="#fff"
                          >
                            <LinkOverlay href='/calendar'>
                              Now Playing
                            </LinkOverlay>
                          </LinkBox>
                        </ListItem>
                        <ListItem>
                          <LinkBox fontSize={{base:'11px', sm:'20px'}}
                            lineHeight={{base:'13px', sm:'22px'}}
                            fontFamily="Libre Franklin, sans-serif"
                            fontWeight="400"
                            padding={{base:'10px 0', sm: '14px 0' }} 
                            color="#fff"
                          >
                            <LinkOverlay href='/cinematheque'>
                              TIFF Cinematheque
                            </LinkOverlay>
                          </LinkBox>
                        </ListItem>
                        <ListItem>
                          <LinkBox fontSize={{base:'11px', sm:'20px'}}
                            lineHeight={{base:'13px', sm:'22px'}}
                            fontFamily="Libre Franklin, sans-serif"
                            fontWeight="400"
                            padding={{base:'10px 0', sm: '14px 0' }} 
                            color="#fff"
                          >
                            <LinkOverlay href='/calendar?newreleases'>
                              New Releases
                            </LinkOverlay>
                          </LinkBox>
                        </ListItem>
                        <ListItem>
                          <LinkBox fontSize={{base:'11px', sm:'20px'}}
                            lineHeight={{base:'13px', sm:'22px'}}
                            fontFamily="Libre Franklin, sans-serif"
                            fontWeight="400"
                            padding={{base:'10px 0', sm: '14px 0' }} 
                            color="#fff"
                          >
                            <LinkOverlay href='/industry-accreditation'>
                              Industry Accreditation & Resources
                            </LinkOverlay>
                          </LinkBox>
                        </ListItem>
                      </UnorderedList>
                    </Box>
                  </Box>
                }
              </Box>

					</DrawerBody>

				</DrawerContent>
			</Drawer>

		</>
	)
}

export default MobileSearchPanel;
